export default __webpack_public_path__ + "static/media/footer.9dff3cb7.png";